/**
 * Returns true when the current user can only see AVP (Armaf) data —
 * i.e. they have exactly the Empresa.AVP role and nothing else.
 *
 * Shares the same ['auth-me'] query as useAllowedEmpresas — no extra API call.
 * Used to apply Armaf-specific display transforms (e.g. article code formatting).
 */
import { useQuery } from '@tanstack/react-query'
import { authApi } from '@/services/api'
export { fmtArticulo } from '@/utils/fmtArticulo'

export function useIsAvpOnly(): boolean {
  const { data } = useQuery({
    queryKey: ['auth-me'],
    queryFn: authApi.getMe,
    staleTime: 60 * 60 * 1000,
    gcTime:    60 * 60 * 1000,
    retry: false,
  })
  const empresas = data?.empresas ?? []
  return empresas.length === 1 && empresas[0] === 'avp'
}
